import React from 'react'
import { SVGProps } from 'react'

const PlotIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.25 3.5h1.5V8h-1.5V3.5Z" />
    <path d="M8 1.6c-.9 1-2.1 1.6-3.3 1.7.5 1.5 1.8 2.6 3.3 2.6s2.8-1.1 3.3-2.6C10.1 3.2 8.9 2.6 8 1.6Z" />
    <path d="M3.4 6.5h1.5v2.3H3.4V6.5Zm7.7 0h1.5v2.3h-1.5V6.5Z" />
    <path d="M4.1 9.8h7.8l2.1 3.4a.8.8 0 0 1-.7 1.3H2.7a.8.8 0 0 1-.7-1.3l2.1-3.4Z" />
  </svg>
)
export default PlotIcon
